import { FastProductVariantWithQuantity } from '@/components/CustomCard/CreatePurchaseOrderItemCard/CreatePurchaseOrderItemCard';
import PurchaseOrderItemDatatable from '@/components/CustomDatatable/PurchaseOrderItemDatatable/PurchaseOrderItemDatatable';
import { OrderStatusEnum } from '@/items/OrderStatus';
import { PurchaseOrderItem } from '@/models/PurchaseOrderItem';
import { Component, Prop, Ref, PropSync, Vue } from 'vue-property-decorator';

@Component<PurchaseOrderOrderItems>({})
export default class PurchaseOrderOrderItems extends Vue {

  // #region @PropSync

  @PropSync('selectedPurchaseOrderItems')
  protected internalSelectedPurchaseOrderItems!: PurchaseOrderItem[];

  // #endregion

  // #region @Props

  @Prop({ default: false })
  protected canEditOrderItems!: boolean;

  @Prop({ default: '' })
  protected purchaseOrderId!: string;

  @Prop({ default: OrderStatusEnum.DRAFT })
  protected purchaseOrderStatus!: OrderStatusEnum;

  // #endregion

  // #region @Refs

  @Ref()
  protected purchaseOrderItemDatatable!: PurchaseOrderItemDatatable;

  // #endregion

  // #region Props

  protected isCreatingOrderItem = false;

  protected selectedProductVariants: FastProductVariantWithQuantity[] = [];

  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers

  protected onOrderItemCreated() {
    setTimeout(() => {
      this.isCreatingOrderItem = false;
    }, 300);

    this.refresh();
  }

  // #endregion

  // #region Helpers

  public refresh(): void {
    if (!this.purchaseOrderItemDatatable) { return; }

    this.purchaseOrderItemDatatable.refresh();
  }

  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters

  protected get showReceivedNotReceived(): boolean {
    return this.purchaseOrderStatus === OrderStatusEnum.RECEIVING;
  }

  protected get showOrderItems(): boolean {
    return !this.showReceivedNotReceived;
  }
  // #endregion

  // #region @Watchers
  // #endregion
}
